import {
  IconDenmark,
  IconFinland,
  IconFrance,
  IconGermany,
  IconGreatBritain,
  IconIreland,
  IconItaly,
  IconLuxembourg,
  IconMalta,
  IconNetherlands,
  IconNorway,
  IconPortugal,
  IconRomania,
  IconSpain,
  IconSweden,
} from '../components';

export const getLanguageFlagById = id => {
  switch (id) {
    case 'english':
      return <IconGreatBritain />;
    case 'french':
      return <IconFrance />;
    case 'german':
      return <IconGermany />;
    case 'dutch':
      return <IconNetherlands />;
    case 'italian':
      return <IconItaly />;
    case 'option-value-spanish':
      return <IconSpain />;
    case 'portuguese':
      return <IconPortugal />;
    case 'option-value-danish':
      return <IconDenmark />;
    case 'norwegian':
      return <IconNorway />;
    case 'swedish':
      return <IconSweden />;
    case 'finnish':
      return <IconFinland />;
    case 'option-value-romanian':
      return <IconRomania />;
    case 'irish':
      return <IconIreland />;
    case 'luxembourgish':
      return <IconLuxembourg />;
    case 'maltese':
      return <IconMalta />;
    default:
      return '';
  }
};
